import requests from "./requests";
import schedules from "./schedules";
import subjects from "./subjects";

export default {
    requests,
    schedules,
    subjects,
};
